/*
 * File: address.ts
 * Project: meki
 * File Created: Tuesday, 9th November 2021 5:40:58 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Saturday, 15th October 2022 12:18:23 am
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { ResolverParams } from '@queries/queries.interfaces';
import { Address, Order } from '@interfaces';

export const getCheckoutAddress = () => gql`
  query getCheckoutAddress($params: CurrentOrderParams) {
    currentOrder(params: $params) {
      id
      deliveryType
      deliveryDate
      orderDetails {
        id
        quantity
        product {
          id
          availability {
            status
            stock
          }
        }
      }
      address {
        ...BaseAddress
      }
    }
    addresses {
      ...BaseAddress
    }
  }
  fragment BaseAddress on Address {
    id
    uuid
    apartment
    commune
    street
    streetNumber
    details
    name
    isConfirmed
    coords
  }
`;

export type GetCheckoutAddressQueryResponse = {
  addresses: Address[];
  currentOrder: Pick<
    Order,
    'id' | 'address' | 'deliveryType' | 'deliveryDate' | 'orderDetails'
  >;
};

export type GetCheckoutAddressQueryParams = ResolverParams<{
  orderUuid: string;
}>;
